import React, { useEffect, useState } from "react";
import CookieManager from "../../services/CookieManager";
import { toast } from "react-toastify";
import { ErrorToast, WarningToast } from "../../pure-components/CustomToast";
import Helper from "../../services/helper";
import { useHistory } from "react-router-dom";
import { BouncingLoader } from "../../pure-components/Loader";
import PaymentHistory from "./paymentHistory";
import API from "../../services/api";
import { Link } from "react-router-dom/cjs/react-router-dom";
import InvoicePopup from "./invoicePopup";
import { CircularProgress } from "@mui/material";
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';

const formatDate = (ms) =>
  new Date(ms).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

const getTimeUntil = (expiryMs) => {
  const now = Date.now();
  const diff = expiryMs - now;
  if (diff <= 0) return "Expired";
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const months = Math.floor(days / 30);
  return months > 0 ? `in ${months} month${months > 1 ? "s" : ""}` : `in ${days} day${days > 1 ? "s" : ""}`;
};

const getStatusBadge = (status) => {
  const lower = status.toLowerCase();
  const common = "px-4 py-1 rounded-full text-sm font-semibold inline-block";
  if (lower === "success") return `${common} bg-green-100 text-green-800`;
  if (lower === "pending") return `${common} bg-yellow-100 text-yellow-800`;
  if (lower === "failed") return `${common} bg-red-100 text-red-800`;
  return `${common} bg-gray-200 text-gray-800`;
};

const getSubscriptionBadge = (active, large = false) => {
  const baseSize = large ? "text-base" : "text-sm";
  const common = `px-4 py-1 rounded-full ${baseSize} inline-block font-medium justify-center `;
  return active
    ? `${common} bg-blue-100 text-blue-800`
    : `${common} bg-gray-300 text-gray-700`;
};

export default function SubscriptionInfo() {
  const history=useHistory();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [openInvoice, setOpenInvoice] = useState(false);

  const [loadingInvoices, setLoadingInvoices] = useState(true);
  const [invoices, setInvoices] = useState([]);

  const [invoiceData, setInvoiceData] = useState(null);
  // const invoiceData = {
  //   id: "inv_SPDWq6RQ1s8vrL",
  //   customer: "Select a customer",
  //   billingAddress: "Billing Address not applicable.",
  //   shippingAddress: "Shipping Address not applicable.",
  //   placeOfSupply: "Place Of Supply not applicable.",
  //   issueDate: "Mar 09, 2026",
  //   expiryDate: "Expiry Date",
  //   items: [
  //     { name: "test 1", price: 1, qty: 1 }
  //   ],
  //   total: 1,
  //   paid: 1,
  //   email : "test@test.com"
  // };


  useEffect(() => {
    const fetchData = async () => {
      await new Promise((res) => setTimeout(res, 300));
      const response = {
        email: "test_01@gmail.com",
        productName: "SOLO_YEARLY",
        productDesc: "Solo Yearly",
        price: 708000,
        interval: "year",
        paymentStatus: "Pending",
        subscriptionStatus: false,
        created: 1749032640951,
        updated: 1749034243591,
        expiry: 1780570243591,
      };
    //   setData(response);
      setLoading(false);
    };
    // fetchData();
    loadSubscriptionData();
  }, []);

  const profileData = JSON.parse(CookieManager.getCookie("user-data") || "{}"); 
    
  const loadSubscriptionData =async()=> {
    const xAccessToken = CookieManager.getCookie("x-access-token");
    if(!profileData || !profileData?.email || profileData?.email?.length === 0){
        toast(({ closeToast }) => <ErrorToast message={"User profile loading error, Please login again."} />);
        setData(null);
        setLoading(false);
        history.push("/login");
        return;
    }

    await fetch(`${process.env.REACT_APP_BASE_URL}api/users/subscription/${Helper.encode(profileData.email)}/true`, 
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': xAccessToken,
                'x-auth': xAccessToken,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        }
    )
    .then(response => {
        // console.log("response : ", response);
        return response.json(); 
    })
    .then(async resp => {
        // console.log('Data received:', resp);
        if(resp?.success){
            setData(resp.data || null);
            setLoading(false);
            if(resp.data?.rp_sub_id?.length > 0)
              await loadSubscriptionInvoices(resp.data.rp_sub_id);
            else
              setLoadingInvoices(false);
        }else{
            toast(({ closeToast }) => <WarningToast message={resp.message} />);
        }
    })
    .catch(error => {
        console.error('Subscription data loading error:', error);
        toast(({ closeToast }) => <ErrorToast message={"Subscription data loading error"} />);
    })
    .finally(() => {
        setLoading(false);
    });
  }

  const loadSubscriptionInvoices =async(subId)=> {
    const xAccessToken = CookieManager.getCookie("x-access-token");
    if(subId?.length === 0){
        console.log("No Subscription Id to load invoices.")
        return;
    }

    await fetch(`${process.env.REACT_APP_BASE_URL}api/users/sub-invoices/${Helper.encode(profileData.email)}/${subId}`, 
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': xAccessToken,
                'x-auth': xAccessToken,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        }
    )
    .then(response => {
        // console.log("response : ", response);
        return response.json(); 
    })
    .then(resp => {
        // console.log('Data received:', resp);
        if(resp?.success){
            setInvoices(resp.data.items || null);
        }else{
            toast(({ closeToast }) => <WarningToast message={resp.message} />);
        }
    })
    .catch(error => {
        console.error('Subscription invoices data loading error:', error);
        toast(({ closeToast }) => <ErrorToast message={"Subscription invoices data loading error"} />);
    })
    .finally(() => {
        setLoadingInvoices(false);
    });
  }

  const showInvoice =(inv) => {
    if(!inv)
      return;
    const tempInvData = {
      id: inv.id,
      customer: profileData.first_name + profileData.last_name?.length > 0 ? " " + profileData.last_name : "",

      issueDate: formatDate(inv.date*1000),
      expiryDate: inv.expire_by ? formatDate(inv.expire_by * 1000) : data.expiry ? formatDate(data.expiry * 1000) : "-",
      items : inv.line_items?.length > 0 ? 
                inv.line_items?.map(e => {
                  return { name: e.name, price: e.amount, qty: e.quantity }
                }) : [],
      total: inv.amount,
      paid: inv.amount_paid,
      email : profileData.email
    }

    setInvoiceData(tempInvData);
    setOpenInvoice(true);
  }
  const payForSubscription = async() => {
    await API.payForSubscription(data.id).then((resp)=>{
      if(resp.data?.length > 0){
                        // setPaymentForm(res.data);
        setTimeout(() => {
            const formContainer = document.createElement('div');
            formContainer.innerHTML = resp.data;
            document.body.appendChild(formContainer);
            
            const form = document.getElementById('paymentForm');
            form.submit();
        }, 3000)
      }
    }).catch(err => {
      console.log("Error while payment link creation. ", err);
    })
  }

  // useEffect(() => {
  //   if(data?.rp_sub_id){
  //     (async() => {
  //       await loadSubscriptionInvoices(data.rp_sub_id)
  //     })();
  //   }
  // },[data])
  useEffect(()=> {
    // console.log("open invoice popup : ", openInvoice)
  },[openInvoice])

  if (loading) return <div className="p-10 text-green-600 text-xl justify-center mt-16 w-full"> <BouncingLoader className="w-full flex "/><div className="w-full flex  justify-center">Loading subscription data...</div></div>;
  if (!data) 
    return (<div className="p-10 w-full lg:flex justify-center mt-16 w-full" >
        <div className="text-red-600 text-xl flex justify-center">No subscription data available.</div>
        <div className="text-green-600 text-xl px-4 cursor-pointer flex justify-center">
          <a href={process.env.REACT_APP_MKT_SITE_PRICING}>Subscribe</a>
        </div>
      </div>)

  return (
    <div className="py-6 px-4 flex items-start justify-center w-full" >
    <div className="w-full max-w-5xl bg-white shadow-xl rounded-2xl p-6 sm:p-8 space-y-6 border-black border-4">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
        <div>
            <h2 className="text-4xl font-bold text-gray-800">{data.productDesc}</h2>
            <p className="text-base text-gray-500">{data.productName}</p>
        </div>
        <div className="flex justify-end gap-2">
          <span className={getSubscriptionBadge(data.subscriptionStatus, true)}>
              {data.subscriptionStatus ? "Active" : "Inactive"}
          </span>
          {/* {profileData.userType !== "FREE" && data.paymentStatus?.toLowerCase() !== "success" &&
            <span className={`mx-1 cursor-pointer ${getSubscriptionBadge(true)}`}
            onClick={() => payForSubscription()}>
              Pay
            </span>} */}
            
          <a className={`mx-1 cursor-pointer ${getSubscriptionBadge(true)}`}
            href={process.env.REACT_APP_MKT_SITE_PRICING}>
              Change Subscription
          </a>
          
        </div>
        </div>

        {/* Info Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700 text-lg">
        <div>
            <p className="text-base text-gray-500">Email</p>
            <p className="font-medium break-words">{data.email}</p>
        </div>

        <div>
            <p className="text-base text-gray-500">Interval</p>
            <span className="inline-block bg-yellow-100 text-yellow-800 text-sm px-3 py-0.5 rounded-full">
            {data.interval}
            </span>
        </div>

        <div>
            <p className="text-base text-gray-500">Price</p>
            <span className="inline-block bg-indigo-100 text-indigo-800 text-sm px-3 py-0.5 rounded-full">
            ₹{(data.price / 100).toLocaleString()}
            </span>
        </div>

        {/* <div>
            <p className="text-base text-gray-500">Payment Status</p>
            <span className={getStatusBadge(data.paymentStatus)}>{data.paymentStatus}</span>
        </div> */}

        <div>
            <p className="text-base text-gray-500">Subscription Status</p>
            <span className={getSubscriptionBadge(data.subscriptionStatus)}>
            {data.subscriptionStatus ? "Active" : "Inactive"}
            </span>
        </div>

        <div>
            <p className="text-base text-gray-500">Created On</p>
            <p>{formatDate(data.created)}</p>   
        </div>

        {/* <div>
            <p className="text-base text-gray-500">Last Updated On</p>
            <p>{formatDate(data.updated)}</p>
        </div> */}

        {data.expiry &&
        <div className="sm:col-span-2 flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <div>
            <p className="text-base text-gray-500">Expires On</p>
            <p>{formatDate(data.expiry * 1000)}</p>
            </div>
            {data.paymentStatus === "Success" &&
            <>{getTimeUntil(data.expiry * 1000) !== "Expired" ? 
            <span className="mt-2 sm:mt-0 inline-flex px-4 py-1 rounded-full bg-gray-200 text-gray-800 text-sm font-medium">
                Expires {getTimeUntil(data.expiry * 1000)}
            </span>
            : <span className="mt-2 sm:mt-0 inline-flex px-4 py-1 rounded-full bg-red-100 text-red-800 text-sm font-medium">
                {getTimeUntil(data.expiry * 1000)}
            </span>}
            </>}
        </div>}
        </div>

        {/* Payment History */}
        {/* <div>
          <PaymentHistory paymentData={data.paymentHistory} subData = {{...data, paymentHistory : {}}} />
        </div> */}
        <div className="w-full">
          <span className="w-full">
            <h2 className="text-2xl font-semibold text-center mb-2">Payment History</h2>
          </span>
          {loadingInvoices && <div className="w-full flex justify-center py-2" ><CircularProgress size='18px'/></div>}
          {!loadingInvoices &&!(invoices?.length > 0)&& <div className="p-6 text-red-600 text-xl w-full flex justify-center w-full">No payment history available.</div>}
          {invoices?.length > 0 && 
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 py-2">
            {invoices.map((inv, index) => (
              <div
                key={index}
                className="cursor-pointer bg-blue-100 text-blue-800 text-sm font-medium px-2 py-1 rounded-full text-center truncate hover:bg-blue-200 transition-colors"
                title={inv.id} // Shows full text on hover if truncated
                onClick={() => {showInvoice(inv)}}
              >
                <ReceiptOutlinedIcon className='mx-2 my-1 ' />
                {inv.id}
              </div>
            ))}
          </div>}
        </div>
        <InvoicePopup
          open={openInvoice}
          onClose={() => {setInvoiceData(null);setOpenInvoice(false)}}
          invoice={invoiceData}
        />
    </div>
    </div>
  );
};
